import { MultiSiteSettings, SiteProfile, SiteTarget } from '../types';

export const DEFAULT_MULTI_SITE_SETTINGS: MultiSiteSettings = {
  apollon: {
    id: 'apollon',
    domain: 'apollonguzellik.com.tr',
    clinicName: 'Apollon Güzellik & Medikal Estetik Merkezi',
    siteName: 'Apollon Güzellik Merkezi',
    tagline: 'Bursa Nilüfer FSM Bulvarı Medikal Cilt Bakımı, Botoks, Dolgu & Lazer Klinikleri',
    phone: '+90 531 239 28 92',
    whatsapp: '905312392892',
    whatsappMessage: 'Merhaba, Apollon Güzellik Merkezi için randevu ve ücretsiz medikal cilt/estetik analizi danışmanlığı almak istiyorum.',
    address: 'Fatih Sultan Mehmet (FSM) Bulvarı, BKM Yanı, Nilüfer / BURSA',
    theme: 'champagne-gold',
    heroTitle: 'Bursa Apollon Güzellik & Medikal Estetik',
    heroSubtitle: 'FSM Bulvarı’nda hekim güvencesiyle medikal cilt bakımı, Hydrafacial, botoks, dolgu, gençlik aşısı, leke protokolleri ve kadın-erkek özel lazer epilasyon klinikleri.',
    metaTitle: 'Bursa Güzellik Merkezi, Medikal Estetik, Botoks & Dolgu | Apollon FSM',
    metaDescription: 'Bursa Nilüfer FSM Bulvarı Apollon Güzellik ve Medikal Estetik Merkezi. Hydrafacial cilt bakımı, botoks, dolgu, gençlik aşısı, mezoterapi ve kadın-erkek buz lazer epilasyon.',
    badgeText: 'Hekim Denetimli Medikal Güzellik & Estetik Merkezi',
    ctaText: 'Ücretsiz Cilt & Estetik Analizi Al'
  },
  erkek: {
    id: 'erkek',
    domain: 'bursaerkeklazer.com.tr',
    clinicName: 'Bursa Erkek Lazer Epilasyon Kliniği',
    siteName: 'Bursa Erkek Lazer Epilasyon',
    tagline: 'Erkek Anatomisine Özel Safir Buz Lazer & %100 Mahremiyet',
    phone: '+90 531 239 28 92',
    whatsapp: '905312392892',
    whatsappMessage: 'Merhaba, Bursa Erkek Lazer Epilasyon Kliniği için bilgi ve ücretsiz kıl analizi randevusu almak istiyorum.',
    address: 'Fatih Sultan Mehmet (FSM) Bulvarı, BKM Yanı, Nilüfer / BURSA',
    theme: 'slate-amber',
    heroTitle: 'Bursa Erkek Lazer Epilasyon',
    heroSubtitle: 'Nilüfer FSM Bulvarı’nda hekim güvencesiyle erkek anatomisine ve derin kıl köküne özel yeni nesil safir buz başlıklı medikal lazer epilasyon.',
    metaTitle: 'Bursa Erkek Lazer Epilasyon | Nilüfer FSM Kliniği - Buz Lazer',
    metaDescription: 'Bursa Nilüfer FSM Bulvarı erkek lazer epilasyon kliniği. Sakal üstü, sırt, göğüs ve özel bölge buz lazer uygulamalarında hekim güvencesi ve acısız konfor.',
    badgeText: 'Hekim Denetimli Erkek Medikal Kliniği',
    ctaText: 'Erkek Lazer Fiyatı Hesapla'
  },
  kadin: {
    id: 'kadin',
    domain: 'bursakadinlazer.com.tr',
    clinicName: 'Bursa Kadın Lazer Epilasyon Kliniği',
    siteName: 'Bursa Kadın Lazer Epilasyon',
    tagline: 'Kadın Estetisyenler Eşliğinde İpeksi Pürüzsüzlük & Safir Buz Konforu',
    phone: '+90 531 239 28 92',
    whatsapp: '905312392892',
    whatsappMessage: 'Merhaba, Bursa Kadın Lazer Epilasyon Kliniği için seans paketleri ve ücretsiz deneme atışı randevusu almak istiyorum.',
    address: 'Fatih Sultan Mehmet (FSM) Bulvarı, BKM Yanı, Nilüfer / BURSA',
    theme: 'rose-gold',
    heroTitle: 'Bursa Kadın Lazer Epilasyon',
    heroSubtitle: 'Nilüfer FSM Bulvarı’nda hekim güvencesi ve uzman kadın estetisyenler eşliğinde batıklara, çilek bacağa son veren acısız safir buz lazer deneyimi.',
    metaTitle: 'Bursa Kadın Lazer Epilasyon | Nilüfer FSM Buz Lazer Kliniği',
    metaDescription: 'Bursa Nilüfer FSM Bulvarı kadın buz lazer epilasyon kliniği. Tüm bacak, koltuk altı, genital ve yüz lazerinde kadın estetisyenler, acısız buz başlık ve hekim güvencesi.',
    badgeText: 'Kadın Estetisyen Eşliğinde %100 Mahremiyet',
    ctaText: 'Kadın Seans Fiyatı Hesapla'
  },
  activePreviewSite: 'apollon',
  updated_at: new Date().toISOString()
};

/**
 * Check if the current hostname is a known official production domain or live server deployment
 */
export const isProductionDomain = (hostname?: string): boolean => {
  if (!hostname && typeof window !== 'undefined') {
    hostname = window.location.hostname;
  }
  if (!hostname) return false;
  const h = hostname.toLowerCase().trim().split(':')[0];

  // Explicit known production domains
  if (
    h === 'apollonguzellik.com' ||
    h === 'apollonguzellik.com.tr' ||
    h === 'www.apollonguzellik.com' ||
    h === 'www.apollonguzellik.com.tr' ||
    h === 'bursaerkeklazer.com' ||
    h === 'bursaerkeklazer.com.tr' ||
    h === 'www.bursaerkeklazer.com' ||
    h === 'www.bursaerkeklazer.com.tr' ||
    h === 'bursakadinlazer.com' ||
    h === 'bursakadinlazer.com.tr' ||
    h === 'www.bursakadinlazer.com' ||
    h === 'www.bursakadinlazer.com.tr'
  ) {
    return true;
  }

  // Any domain that is NOT local development or AI Studio preview container
  const isPreview =
    h.includes('localhost') ||
    h.includes('127.0.0.1') ||
    h.includes('0.0.0.0') ||
    h.includes('ais-dev') ||
    h.includes('ais-pre') ||
    h.endsWith('.run.app') ||
    h.endsWith('.web.app');

  return !isPreview;
};

/**
 * Determine if the multi-site / portal switcher UI controls should be rendered
 * In production / on server, this MUST return false so visitors never see portal toggles.
 */
export const shouldShowSiteSwitcher = (): boolean => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname.toLowerCase().trim().split(':')[0];

  // In production / live server domains, NEVER show the portal switcher
  if (isProductionDomain(hostname)) {
    return false;
  }

  // Only show in preview/development environment
  return (
    hostname.includes('localhost') ||
    hostname.includes('127.0.0.1') ||
    hostname.includes('0.0.0.0') ||
    hostname.includes('ais-dev') ||
    hostname.includes('ais-pre') ||
    hostname.endsWith('.run.app')
  );
};

/**
 * Detect active site from hostname
 */
export const detectSiteFromHostname = (hostname: string): SiteTarget => {
  if (!hostname) return 'apollon';
  const clean = hostname.toLowerCase().trim().split(':')[0];
  if (clean.includes('kadin') || clean.includes('bursakadin') || clean.includes('female')) {
    return 'kadin';
  }
  if (clean.includes('erkek') || clean.includes('bursaerkek') || clean.includes('male')) {
    return 'erkek';
  }
  if (clean.includes('apollon') || clean.includes('guzellik')) {
    return 'apollon';
  }
  return 'apollon';
};

/**
 * Detect active site mode on client side based on hostname or server injection
 * NOTE: Production domains (apollonguzellik.* vs bursaerkeklazer.* vs bursakadinlazer.*) ALWAYS strictly lock to their domain
 * and ignore any ?site= query parameter to prevent Googlebot crawling mismatch.
 */
export const detectCurrentSiteMode = (settings?: MultiSiteSettings): SiteTarget => {
  if (typeof window === 'undefined') return 'apollon';

  const hostname = window.location.hostname.toLowerCase().trim().split(':')[0];

  // 0. Server-Injected Initial Site Mode (when SSR or HTML injects window.__INITIAL_SITE_MODE__)
  if (typeof (window as any).__INITIAL_SITE_MODE__ === 'string') {
    const injected = (window as any).__INITIAL_SITE_MODE__;
    if (injected === 'apollon' || injected === 'kadin' || injected === 'erkek') {
      if (isProductionDomain(hostname)) {
        return injected;
      }
    }
  }

  // 1. Strict Production Domain Enforcement (Absolute priority over query params & localStorage)
  if (isProductionDomain(hostname)) {
    if (hostname.includes('kadin') || hostname.includes('bursakadin') || hostname.includes('female')) {
      return 'kadin';
    }
    if (hostname.includes('erkek') || hostname.includes('bursaerkek') || hostname.includes('male')) {
      return 'erkek';
    }
    if (hostname.includes('apollon') || hostname.includes('guzellik')) {
      return 'apollon';
    }
    return 'apollon';
  }

  // 2. Dynamic Domain Check from Staging or Multi-Site Settings
  const kadinDomain = (settings?.kadin?.domain || 'bursakadinlazer.com.tr').toLowerCase().replace(/^https?:\/\//, '').split('/')[0].split(':')[0];
  const erkekDomain = (settings?.erkek?.domain || 'bursaerkeklazer.com.tr').toLowerCase().replace(/^https?:\/\//, '').split('/')[0].split(':')[0];
  const apollonDomain = (settings?.apollon?.domain || 'apollonguzellik.com.tr').toLowerCase().replace(/^https?:\/\//, '').split('/')[0].split(':')[0];

  if (hostname === kadinDomain || hostname.includes('kadin') || hostname.includes('bursakadin')) {
    return 'kadin';
  }
  if (hostname === erkekDomain || hostname.includes('erkek') || hostname.includes('bursaerkek')) {
    return 'erkek';
  }
  if (hostname === apollonDomain || hostname.includes('apollon')) {
    return 'apollon';
  }

  // 3. Development / Staging / AI Studio Preview ONLY: Allow query param or local storage override
  const urlParams = new URLSearchParams(window.location.search);
  const siteParam = urlParams.get('site') || urlParams.get('mode');
  if (siteParam === 'apollon' || siteParam === 'guzellik' || siteParam === 'main') return 'apollon';
  if (siteParam === 'kadin' || siteParam === 'kadın' || siteParam === 'female') return 'kadin';
  if (siteParam === 'erkek' || siteParam === 'male') return 'erkek';

  try {
    const savedPreview = localStorage.getItem('active_preview_site_mode') || localStorage.getItem('bursa_active_site_preview');
    if (savedPreview === 'apollon') return 'apollon';
    if (savedPreview === 'kadin') return 'kadin';
    if (savedPreview === 'erkek') return 'erkek';
  } catch {}

  return 'apollon';
};
